<template>
    <div :class="statusColor" class="purchase_part-header">
        <p class="purchase_part-header_number" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            <b-badge v-if="purchase.auth_is_supplier" class="my-auto fs-14 mr-2" variant="danger">Поставщик</b-badge>
            <b-badge class="my-auto fs-14 mr-2" variant="primary">{{ purchase.product.short_title }}</b-badge>
            <b-badge v-if="purchase.product.is_external" class="my-auto fs-14 mr-2">Вне ИС</b-badge>
            <template v-if="isPurchasePubliclyAvailable">
                <router-link v-if="purchase.type === 'fl44_external'" :to="{ name: 'ExternalPurchaseShow', params: { id: purchase.id } }" class="white-system_link-style" exact target="_blank">{{ purchase.purchase_info.reg_number }}</router-link>
                <router-link v-else-if="purchase.type === 'fl44_unknown_volume'" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: purchase.id } }" class="white-system_link-style" exact target="_blank">{{ purchase.purchase_info.reg_number }}</router-link>
                <router-link v-else :to="{ name: 'purchases.grouped.item.view', params: { group: 'fl44', id: purchase.id } }" class="white-system_link-style" target="_blank">{{ purchase.purchase_info.reg_number }} </router-link>
            </template>
            <template v-else>
                <span>{{ purchase.purchase_info.reg_number }}</span>
            </template>
            <span v-if="purchase.purchase_info.purchase_object" style="text-overflow: ellipsis ellipsis">&nbsp;На закупку "{{ purchase.purchase_info.purchase_object }}"</span>
        </p>
        <p class="purchase_part-header_label fw-600 float-right text-right my-auto fs-14 text-nowrap ml-4">
            {{ purchase.status.title }}
            <i :class="statusIconClass" class="atmo-icon ml-2"></i>
        </p>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-card-header',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isPurchasePubliclyAvailable() {
            return !this.purchase.status.stage.includes('non_public');
        },
        statusColor() {
            switch (this.purchase.status.id) {
                case 'contract:unfulfilled':
                case 'contract:terminated':
                case 'cancelled':
                case 'failed':
                case 'contract:failed':
                case 'blocked':
                case 'contract:blocked':
                    return 'status_color_yellow';
                case 'accepting':
                    return 'status_color_grey';
                case 'summarizing':
                case 'summarized':
                    return 'status_color_red';
                case 'draft':
                case 'signed':
                case 'contract:active':
                case 'contract:fulfilled':
                default:
                    return 'status_color_green';
            }
        },
        statusIconClass() {
            switch (this.purchase.status.id) {
                case 'draft':
                case 'signed':
                case 'revoked':
                    return '';
                case 'accepting':
                    return 'atmo-icon-stopwatch';
                case 'summarizing':
                    return 'atmo-icon-summation';
                case 'summarized':
                    return 'atmo-icon-shield';
                case 'failed':
                case 'contract:failed':
                case 'cancelled':
                case 'blocked':
                case 'contract:blocked':
                    return 'atmo-icon-cancelled';
                case 'contract:active':
                    return 'atmo-icon-contract';
                case 'contract:fulfilled':
                    return 'atmo-icon-fulfilled';
                case 'contract:unfulfilled':
                    return 'atmo-icon-cancelled';
                case 'contract:terminated':
                    return 'atmo-icon-cancelled';
                default:
                    return '';
            }
        }
    }
};
</script>

<style scoped>
.purchase_part-header {
    -webkit-border-radius: 3px 3px 0 0;
    -moz-border-radius: 3px 3px 0 0;
    border-radius: 3px 3px 0 0;
    background-color: #959ba4;
    padding: 9px 11px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.purchase_part-header_number {
    font-size: 14px !important;
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.purchase_part-header_label {
    text-transform: uppercase;
    color: #fff;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 14px !important;
}

@media screen and (max-width: 420px) {
    .purchase_part-header {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: start;
        -webkit-align-items: flex-start;
        -moz-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -moz-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        min-height: 65px;
    }
}
</style>
